import React from "react";

type OLProps = {
  ordered: boolean;
  [key: string]: any;
};

/**
 * `omit` is not working for extracting ordered prop from all props
 * that's why we implemented following approach. Kindly refer to this link.
 * https://github.com/orgs/remarkjs/discussions/873
 * Same pattern as UL component.
 */
export function OL({
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  ordered,
  ...props
}: OLProps) {
  return (
    <ol
      className="list-decimal pl-4 rtl:pl-0 rtl:pr-4 whitespace-normal"
      {...props}
    />
  );
}
